import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HomeDashboard from "../../components/dashboardHome/HomeDashboard";
import { clientSelector, getClients } from "../../redux/clientSlice";
import { getAllSurveys, surveysSelector } from "../../redux/surveySlice";
import { getAllTemplate } from "../../redux/templateSlice";
import {
  getSurveyors,
  surveyorSelector,
  userSelector,
} from "../../redux/userSlice";

const Dashboard = () => {
  const dispatch = useDispatch();
  const surveys = useSelector(surveysSelector);
  const { allClients } = useSelector(clientSelector);
  const surveyors = useSelector(surveyorSelector);

  useEffect(() => {
    getSurveys(20, 1);
    getAllClients();
    getAllSurveyors();
    getTemplates();
  }, []);

  const getSurveys = async (pageSize, pageNum) => {
    dispatch(getAllSurveys({ pageSize, pageNum, searchText: "" }));
  };

  const getTemplates = async () => {
    dispatch(getAllTemplate({ search: "" }));
  };

  const getAllClients = async () => {
    dispatch(getClients({ pageNum: 1, searchText: "" }));
  };

  const getAllSurveyors = async () => {
    dispatch(getSurveyors({ pageNum: 1, searchText: "" }));
  };
  return (
    <>
      <div className="main-dashboard">
        <div className="mainWrapper">
          <HomeDashboard
            surveys={surveys}
            clients={allClients}
            surveyors={surveyors}
            getSurveys={getSurveys}
          />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
